<template>
    <div class="bonus">
        <div class="card">
            <div class="card__header">
				<h4 class="card__title">Бесплатные бонусы</h4>
            </div>
            <div class="card__body">
				<div class="bonus__tabs no-scrollbar">
					<button class="bonus__tab btn" :class="[active === 'promo1' ? 'btn--primary' : 'btn--white']" @click="active = 'promo1'" type="button">
						Ежедневная раздача
					</button>
					<button class="bonus__tab btn" :class="[active === 'rakeback' ? 'btn--primary' : 'btn--white']" @click="active = 'rakeback'" type="button">
						Рейкбек
					</button>
					<button class="bonus__tab btn" :class="[active === 'cashback' ? 'btn--primary' : 'btn--white']" @click="active = 'cashback'" type="button">
						Кешбек
					</button>
					<button class="bonus__tab btn" :class="[active === 'promo2' ? 'btn--primary' : 'btn--white']" @click="active = 'promo2'" type="button">
						Промокод
					</button>
					<button class="bonus__tab btn" :class="[active === 'subcribe' ? 'btn--primary' : 'btn--white']" @click="active = 'subcribe'" type="button">
						Подписки
					</button>
					<button class="bonus__tab btn" :class="[active === 'freespin' ? 'btn--primary' : 'btn--white']" @click="active = 'freespin'" type="button">
						Фриспины
					</button>
				</div>
				<!-- Start Daily bonus -->
				<div v-if="active === 'promo1'" class="bonus__section" id="promo1">
					<svg class="fields__item" height="100" width="100">
						<use href="#svg-icon-bonus"></use>
					</svg>
					<h4 class="fields__item">
						До 10 ₽ на баланс ежедневно и до 100 ₽ на баланс в субботу
					</h4>
					<div v-if="showCountdown" class="alert alert--warning text-center">
						Для получения бонуса осталось:
						<b> {{ countdown.hours }}:{{ countdown.minutes }}:{{ countdown.seconds }}</b>
					</div>
					<div v-else class="bonus__actions">
						<button type="button" class="btn btn--primary" @click="getPromoSocket">
							Получить
						</button>
					</div>
				</div>
				<!-- End daily bonus -->

				<!-- Start Subscribe bonus -->
				<div v-if="active === 'subcribe'" class="bonus__section" id="subcribe">
					<div class="bonus__subscribes">
						<div class="bonus__subscribe">
							<div class="card">
								<div class="card__header">
									<h4 class="card__title bonus__subcribe-title">Бонусы за активность в ВК</h4>
								</div>

								<div class="card__body text-left">
									<div class="bonus__subscribe-content">
										<div class="fields__col">
											<h5 class="bonus__subscribe-title">Выполните условия</h5>
											<div class="bonus__subscribe-row">
												<img class="bonus__subscribe-icon" src="/images/vk.svg" width="23px">
												Получите 2₽ за подписку на <a :href="$root.$link.vk" target="_blank"> группу ВК</a>
											</div>
										</div>
										<div class="fields__col">
											<h5 class="bonus__subscribe-subtitle">Дополнительные бонусы</h5>
											<!-- <div class="bonus__subscribe-row">
												• Получите 25 ₽ за репост закрепа <br> (бонус зачисляется если репост будет 7 дней в закрепе на открытом аккаунте)
											</div> -->
											<div class="bonus__subscribe-row">
												• Получите 10₽ за репост <a target="_blank" href="https://vk.com/avocado_casino?w=wall-224499436_5">поста</a>
											</div>
											<div class="bonus__subscribe-row">
												• Получите 1₽ за <a @click="getBonusForLink('vkontakte')" href="#">привязку Вконтакте</a>
											</div>
											<div class="bonus__subscribe-row">
												• Получайте 0.4₽ за репосты постов
											</div>
											<div class="bonus__subscribe-row">
												• Получайте 0.1₽ за лайки к постам
											</div>
										</div>
									</div>

									<button @click="subscribeVk" v-if="!hasSubscribeVK" class="btn btn--lg btn--primary btn--block bonus__subscribe-btn">
										Получить бонус
									</button>
									<!-- <button v-else-if="needSubscribeVK" @click="$root.OAuth('vkontakte')" class="btn btn--lg bonus__subscribe-btn btn--primary btn--block">
										Привязать Вконтакте
									</button> -->
									<button v-else disabled class="btn btn--lg btn--primary btn--block bonus__subscribe-btn">
										Бонус активирован
									</button>
								</div>
							</div>
						</div>

						<div class="bonus__subscribe">
							<div class="card">
								<div class="card__header">
									<h4 class="card__title bonus__subcribe-title">Бонусы за активность в TG</h4>
								</div>

								<div class="card__body text-left">
									<div class="bonus__subscribe-content">
										<div class="fields__col">
											<h5 class="bonus__subscribe-title">Выполните условия</h5>
											<div class="bonus__subscribe-row">
												<img class="bonus__subscribe-icon" src="/images/tg.svg" width="23px" alt="">
												Получите 2₽ за подписку на <a :href="$root.$link.tg" target="_blank">TG&nbsp;Канал</a>
											</div>
										</div>
										<div class="fields__col">
											<h5 class="bonus__subscribe-subtitle">Дополнительные бонусы</h5>
											<div class="bonus__subscribe-row">
												• Получите 1₽ за <a @click="getBonusForLink('telegram')" href="#">привязку телеграма</a>
											</div>
										</div>
									</div>

									<button @click="subscribeTg" v-if="!hasSubscribeTg" class="btn btn--lg btn--primary btn--block bonus__subscribe-btn">
										Получить бонус
									</button>
									<!-- <button v-else-if="needSubscribeTg" @click="$root.OAuth('telegram')" class="btn btn--lg btn--primary btn--block bonus__subscribe-btn">
										Привязать Телеграм
									</button> -->
									<button v-else disabled class="btn btn--lg btn--primary btn--block bonus__subscribe-btn">
										Бонус активирован
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- End Subscribe bonus -->

				<!-- Start promocode -->
				<div v-if="active === 'promo2'" class="bonus__section" id="promo2">
					<PromocodeActivations />
					<div class="bonus__promo">
						<img :src="'/assets/avocado/images/bonus-promo.svg'" alt="">

						<h4 class="fields__item">Введите промокод</h4>
						<div class="fields__item">
							<input class="bonus__promo-input text-field__input" v-model="promocode" placeholder="" type="text" autocomplete="do-not-autofill" />
						</div>

						<div class="fields__item">
							<vue-recaptcha
								ref="recaptcha"
								cssClass="bonus-recaptcha"
								:sitekey="$root.$reCaptchaSiteKey"
								@verify="onCaptchaVerified"
								@expired="onCaptchaExpired">
							</vue-recaptcha>
						</div>

						<div class="bonus__actions fields__item">
							<button class="btn btn--primary" @click="actPromoSocket">Активировать</button>
						</div>
						<a v-if="nevk" :href="$root.$link.vk" class="btn btn--success">
							Перейти в группу
						</a>
					</div>
				</div>
				<!-- End promocode -->

				<!-- Start rakeback -->
				<div v-if="active === 'rakeback'" class="bonus__section" id="rakeback">
					<div class="alert alert--info">
						Каждый <b>вторник</b> вы можете забрать свои накопленные бонусы рейкбека. Рейкбек начисляется с каждой вашей ставки за предыдущие 7 дней и зависит от вашего ранга.<br />
						<span v-if="rakeback">
							Сумма ваших ставок с <b>{{ rakeback.start }}</b> по <b>{{ rakeback.end }}</b>: <b>{{ $root.currency(rakeback.profit) }}</b><br/>
							Информация актуальна на: <b>{{ user.profit_calculated_at }}</b>
						</span>
					</div>
					<div class="bonus__actions">
						<button v-if="!rakeback || !rakeback.is_available" class="btn btn--xs btn--white"
								@click="takeRakeback"
								:disabled="!rakeback || !rakeback.is_available"
								:class="{ disabled: !rakeback || !rakeback.is_available }">
							Баланс рейкбека {{ $root.currency(rakeback ? rakeback.amount : 0) }}
						</button>
						<button v-else class="btn btn--brand"
								@click="takeRakeback">
							Доступно к снятию {{ $root.currency(rakeback ? rakeback.amount : 0) }}
						</button>
					</div>
				</div>
				<!-- End rakeback -->

				<!-- Start cashback -->
				<div v-if="active === 'cashback'" class="bonus__section" id="cashback">
					<div class="alert alert--info">
						Каждый <b>понедельник</b> и <b>четверг</b> вы можете забрать свои накопленные бонусы кешбека. Кешбек начисляется на отрицательный профит за предыдущие дни и зависит от вашего ранга.<br />
						В <b>понедельник</b> вы можете забрать кешбек, который был накоплен с <b>четверга</b> по <b>воскресенье</b>.<br />
						В <b>четверг</b> вы можете забрать кешбек, который был накоплен с <b>понедельника</b> по <b>среду</b>.<br />
						<span v-if="cashback">
							Ваш профит с <b>{{ cashback.start }}</b> по <b>{{ cashback.end }}</b>: <b>{{ $root.currency(cashback.profit) }}</b><br />
							Информация актуальна на: <b>{{ user.profit_calculated_at }}</b>
						</span>
					</div>
					<div class="bonus__actions">
						<button v-if="!cashback || !cashback.is_available" class="btn btn--xs btn--white"
								:disabled="!cashback || !cashback.is_available"
								:class="{ disabled: !cashback || !cashback.is_available }">
							Баланс кешбека {{ $root.currency(cashback ? cashback.amount : 0) }}
						</button>
						<button v-else class="btn btn--brand" @click="takeCashback">
							Доступно к снятию {{ $root.currency(cashback ? this.cashback.amount : 0) }}
						</button>
					</div>
				</div>
				<!-- End cashback -->

				<!-- Start freespin -->
				<div v-if="active === 'freespin'" class="bonus__section" id="freespin">
					<div class="alert alert--info">
						Каждую <b>пятницу</b> вы можете забрать свои фриспины. Фриспины начисляеются в случае, если отрицательный профит за предыдущие 7 дней больше 5000 рублей. Чем больше ваш отрицательный профит, тем больше фриспинов получите.<br />
						<span v-if="freespin">
							Ваш профит с <b>{{ freespin.start }}</b> по <b>{{ freespin.end }}</b>: <b>{{ $root.currency(freespin.profit) }}</b><br />
							Информация актуальна на: <b>{{ user.profit_calculated_at }}</b>
						</span>
					</div>
					<h4 class="fields__item text-center" v-if="!freespins.length">
						У вас нет активных фриспинов
					</h4>
					<div class="bonus__freespins" v-if="freespins.length">
						<div class="bonus__freespin" v-for="(freespin) in freespins">
							<div class="bonus__freespin-inner">
								<div class="bonus__freespin-banner">
									<img class="bonus__freespin-banner-img" :src="freespin.game_image" alt=""/>
								</div>
								<div class="bonus__freespin-content">
									<h5 class="bonus__freespin-name">{{ freespin.game_name }}</h5>
									<div>
										Осталось <b>{{ freespin.quantity_left }}</b> спинов по <b>{{ freespin.bet_amount }}</b> ₽
									</div>
									<div class="small text-muted">
										Активно до {{ $root.moment(freespin.valid_until).format('YYYY-MM-DD, HH:mm') }}
									</div>
								</div>
							</div>
							<div v-if="isMobile" class="btn btn--primary btn--block bonus__freespin-action" @click="getGame(freespin.game_id)"></div>
							<router-link :to="{name: 'slotsGame', params: { gameId: freespin.game_id }}" class="btn btn--primary btn--block bonus__freespin-action">
								Играть
							</router-link>
						</div>
					</div>
				</div>
				<!-- End freespin -->
            </div>
        </div>
    </div>
</template>

<script>
    import VueRecaptcha from './../../components/googlerecaptcha/GoogleReCaptcha.vue';
    import PromocodeActivations from './PromocodeActivations.vue';
	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';
	import breakpointsMixin from "../../mixins/breakpoints-mixin.vue";
	
	const TYPE_FREESPIN = 'freespin';

    export default {
		mixins: [
			breakpointsMixin
		],

        components: {
            VueRecaptcha,
            PromocodeActivations
        },
        data() {
            return {
                bonus_countdown: 0,
                nevk: false,
                cashback: null,
                rakeback: null,
                freespins: [],
                freespin: null,
                hasSubscribeVK: false,
                hasSubscribeTg: false,
                needSubscribeVK: false,
                needSubscribeTg: false,
                disableBtnGetPromo: false,
                promocode: '',
                disableBtnSetPromo: false,
                gRecaptchaResponse: null,
                showCountdown: false,
                countdown: {},
				active: 'promo1'
            }
        },
        mounted() {
            this.$root.isLoading = true;

            if (!this.$cookie.get('token')) {
                this.$router.go(-1);
            }

            this.getBonusInfo();
        },

		computed: {
			...mapState(useUserStore, ['user'])
		},

        methods: {
            getBonusForLink(provider) {
                if (provider == 'vkontakte' && this.user.vkontakte) {
                    return this.$toast.error("Вы уже получали данный бонус");
                }
                if (provider == 'telegram' && this.user.telegram) {
                    return this.$toast.error("Вы уже получали данный бонус");
                }

                this.$root.OAuth(provider);
            },
			getPromoSocket() {
				if (this.disableBtnGetPromo) {
					return;
				}

				this.disableBtnGetPromo = true;

				this.$root.axios.post('/api/bonus/daily')
					.then(res => {
						const data = res.data;

						if (data.success) {
							this.$toast.success(data.message);
							this.user.balance += data.amount;
							this.bonus_countdown = data.bonus_countdown;
							this.dailyBonusTimer();
						} else {
							this.$toast.error(data.message);

							this.disableBtnGetPromo = false;
						}
					}).catch(error => {
						this.$toast.error(this.$root.graphql.axiosGetError(error));

						this.disableBtnGetPromo = false;
					});
			},
            takeCashback() {
                this.$root.axios.post('/api/bonus/cashback/take')
                .then(res => {
                    const data = res.data;

                    if(data.success) {
                        this.cashback = data.info;
                        this.user.balance += data.amount;

                        this.$toast.success(data.message);
                    } else {
                        this.$toast.error(data.message);
                    }
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            takeRakeback() {
                this.$root.axios.post('/api/bonus/rakeback/take')
                .then(res => {
                    const data = res.data;

                    if(data.success) {
                        this.rakeback = data.info;
                        
                        this.user.balance += data.amount;

                        this.$toast.success(data.message);
                    } else {
                        this.$toast.error(data.message);
                    }
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            subscribeVk() {
                this.$root.axios.post('/api/bonus/subscribe/vk')
                .then(res => {
                    const data = res.data;

                    if(data.success) {
                        this.hasSubscribeVK = true;
                        this.user.balance = data.balance;

                        this.$toast.success(data.message);
                    } else {
                        this.$toast.error(data.message);
                    }
                }).catch(error => {
                    var message = this.$root.graphql.axiosGetError(error);
                    if (message == "Требуется привязанный аккаунт VK") {
                        this.needSubscribeVK = true;
                        this.$root.OAuth('vkontakte');
                    }
                    this.$toast.error(message);
                });
            },
            subscribeTg() {
                this.$root.axios.post('/api/bonus/subscribe/tg')
                .then(res => {
                    const data = res.data;

                    if(data.success) {
                        this.hasSubscribeTg = true;
                        this.user.balance = data.balance;

                        this.$toast.success(data.message);
                    } else {
                        this.$toast.error(data.message);
                    }
                }).catch(error => {
                    var message = this.$root.graphql.axiosGetError(error);

                    if (message == "Требуется привязанный аккаунт Telegram") {
                        this.needSubscribeTg = true;
                        this.$root.OAuth('telegram');

                    }
                    this.$toast.error(message);
                });
            },
			actPromoSocket() {
				if (!this.gRecaptchaResponse) {
					return this.$toast.error('Необходимо пройти капчу');
				}

				if (this.disableBtnSetPromo) {
					return;
				}

				this.disableBtnSetPromo = true;

				this.$root.axios.post('/api/bonus/promo', {
					code: this.promocode,
					recaptcha: this.gRecaptchaResponse
				}).then(res => {
					const data = res.data;

					if (data.success) {
						if (data.type === TYPE_FREESPIN) {
							this.getBonusInfo();
						}

						this.$toast.success(data.message);
						this.$root.emitter.emit('promocode.activated');
						this.user.balance = data.balance;
					} else {
						if (data.message === "Вы не состоите в группе") {
							this.nevk = true;
						}

						this.$toast.error(data.message);
					}

					this.disableBtnSetPromo = false;
				}).catch(error => {
					this.$toast.error(this.$root.graphql.axiosGetError(error));

					this.disableBtnSetPromo = false;
				});

				this.onCaptchaExpired();
			},
            getBonusInfo() {
                this.$root.axios.get('/api/bonus/info')
                .then(res => {
                    const data = res.data;

                    this.bonus_countdown = data.bonus_countdown;
                    this.cashback = data.cashback;
                    this.rakeback = data.rakeback;
                    this.freespins = data.freespins;
                    this.freespin = data.freespin;

                    this.hasSubscribeTg = data.has_subscribe_tg;
                    this.hasSubscribeVK = data.has_subscribe_vk;

                    this.dailyBonusTimer();

                    this.$root.isLoading = false;
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            dailyBonusTimer() {
                let self = this;

                if(!self.bonus_countdown) {
                    return self.showCountdown = false;
                }

                // Update the count down every 1 second
                let x = setInterval(function() {
                    if(self.bonus_countdown  && !self.showCountdown) {
                        self.showCountdown = true;
                    }

                    // If the count down is finished, write some text
                    if (!self.bonus_countdown) {
                        clearInterval(x);
                        
                        return self.showCountdown = false;
                    }

                    // Time calculations for days, hours, minutes and seconds
                    self.countdown = {
                        days: Math.floor(self.bonus_countdown / (60 * 60 * 24)),
                        hours: Math.floor((self.bonus_countdown  % (60 * 60 * 24)) / (60 * 60)),
                        minutes: Math.floor((self.bonus_countdown  % (60 * 60)) / (60)),
                        seconds: Math.floor((self.bonus_countdown  % (60)))
                    };

                    --self.bonus_countdown;
                }, 1000);
            },
            onCaptchaVerified(response) {
                this.gRecaptchaResponse = response;
            },
            onCaptchaExpired() {
                this.$refs.recaptcha.reset()
            },
			getGame(gameId) {
				this.isLoading = true;

				this.$root.axios.post('/api/slots/init', {
					game_id: gameId,
					mobile: true
				}).then(res => {
					const data = res.data;
					window.location.href = data?.url?.launch_options?.game_url ?? data?.url;
				}).catch(error => {
					this.error = {
						show: true,
						text: this.$root.graphql.axiosGetError(error)
					};

					this.$root.isLoading = false;
				})
			}
        }
    }
</script>